import { problems } from "@/mocks/llkContent";
import { ScrollReveal } from "@/components/animations/ScrollReveal";
import { StaggerContainer, StaggerItem } from "@/components/animations/StaggerContainer";

export default function ProblemSection() {
  return (
    <section className="relative py-20 md:py-28 bg-llk-cream">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <ScrollReveal>
          <p className="text-center text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-llk-dark/60 mb-4">
            A REALIDADE DO CAMPO
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <h2 className="text-center font-display text-xl sm:text-2xl md:text-3xl lg:text-[2.5rem] text-llk-dark font-semibold leading-snug mb-5 max-w-3xl mx-auto">
            Sua lavoura pode estar perdendo potencial antes de expressar todo o resultado
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <p className="text-center text-llk-dark/60 text-base md:text-lg max-w-2xl mx-auto mb-12 md:mb-16">
            Raízes mal protegidas, solo com baixa atividade biológica, fungos, nematoides, estresse climático e baixa absorção de nutrientes podem comprometer a planta.
          </p>
        </ScrollReveal>

        <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" staggerDelay={0.1} delayChildren={0.2}>
          {problems.map((problem) => (
            <StaggerItem key={problem.title}>
              <div className="group relative p-6 md:p-8 rounded-2xl bg-llk-dark text-white transition-all duration-500 hover:-translate-y-1 h-full">
                <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center mb-5 group-hover:bg-llk-gold/20 transition-colors">
                  <i className={`${problem.icon} text-xl text-llk-gold`} />
                </div>
                <h3 className="text-lg font-semibold mb-3">{problem.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{problem.description}</p>
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-llk-gold to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-b-2xl" />
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}